/**
 * Temporary UI split for Selected course until backend adds a dedicated Degree field.
 * Example: "Bachelor's in Public Health 3rd year"
 * → degree: "Bachelor's in", selectedCourse: "Public Health 3rd year"
 */
export const splitSelectedCourse = (value?: string | null): { degree: string; selectedCourse: string } => {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return { degree: "", selectedCourse: "" };

  const match = trimmed.match(/^(.+?\s+in)\s+(.+)$/i);
  if (!match) return { degree: "", selectedCourse: trimmed };

  return {
    degree: match[1].trim(),
    selectedCourse: match[2].trim(),
  };
};

/** Join Degree + Selected course for qarshisu.net document creation API only. */
export const joinSelectedCourse = (degree?: string | null, selectedCourse?: string | null): string => {
  const degreePart = (degree ?? "").trim();
  const coursePart = (selectedCourse ?? "").trim();
  if (!degreePart) return coursePart;
  if (!coursePart) return degreePart;
  return `${degreePart} ${coursePart}`;
};
